import React from 'react';
import '../../App.css';
import './LegalPages.css';
import Footer from '../Footer';

function TermsOfService() {
    return (
        <>
            <div className='legal-page'>
                <div className='legal-container'>
                    <h1>Terms of Service</h1>

                    <h2>OVERVIEW</h2>
                    <p>
                        This website is operated by OFFF THE ROAST. Throughout the site, the terms "we",
                        "us" and "our" refer to OFFF THE ROAST. We offer this website, including all
                        information, tools, and Services available from this site to you, the user,
                        conditioned upon your acceptance of all terms, conditions, policies, and notices
                        stated here.
                    </p>
                    <p>
                        By visiting our site and/or purchasing a roasting session from us, you engage in
                        our "Service" and agree to be bound by the following terms and conditions ("Terms
                        of Service", "Terms"). Please read these Terms carefully before accessing our
                        website or booking a session.
                    </p>

                    <h2>SECTION 1 – ROASTING SESSIONS & DEPOSITS</h2>
                    <p>
                        <strong>Deposit Requirement:</strong> A $50 deposit is required to secure your
                        roasting session. This amount will be applied toward your final total.
                    </p>
                    <p>
                        <strong>Non-Refundability:</strong> This deposit is non-refundable for
                        cancellations made with less than 48 hours' notice or for no-shows.
                    </p>
                    <p>
                        <strong>Transferability:</strong> The deposit is fully transferable to a future
                        date if you reschedule at least 48 hours in advance.
                    </p>

                    <h2>SECTION 2 – ONLINE STORE TERMS</h2>
                    <p>
                        By agreeing to these Terms, you represent that you are at least the age of
                        majority in your state of residence.
                    </p>
                    <p>
                        You may not use our products or services for any illegal or unauthorized purpose.
                    </p>
                    <p>
                        A breach or violation of any of the Terms will result in an immediate termination
                        of your Services.
                    </p>

                    <h2>SECTION 3 – MODIFICATIONS TO THE SERVICE AND PRICES</h2>
                    <p>
                        Prices for our roasting sessions are subject to change without notice.
                    </p>
                    <p>
                        We reserve the right at any time to modify or discontinue a Service (or any part
                        thereof) without notice at any time.
                    </p>
                    <p>
                        We shall not be liable to you or to any third-party for any modification, price
                        change, or discontinuance of the Service.
                    </p>

                    <h2>SECTION 4 – ACCURACY OF BILLING AND ACCOUNT INFORMATION</h2>
                    <p>
                        We reserve the right to refuse any order you place with us.
                    </p>
                    <p>
                        You agree to provide current, complete, and accurate purchase and account
                        information for all bookings.
                    </p>
                    <p>
                        You agree to promptly update your account and other information, including your
                        email address and credit card details, so that we can complete your transactions.
                    </p>

                    <h2>SECTION 5 – PROHIBITED USES</h2>
                    <p>You are prohibited from using the site or its content:</p>
                    <p>For any unlawful purpose or to solicit others to perform unlawful acts.</p>
                    <p>
                        To infringe upon or violate our intellectual property rights or the intellectual
                        property rights of others.
                    </p>
                    <p>To submit false or misleading information.</p>
                    <p>To collect or track the personal information of others.</p>

                    <h2>SECTION 6 – LIMITATION OF LIABILITY</h2>
                    <p>
                        OFFF THE ROAST does not guarantee that your use of our Service will be
                        uninterrupted, timely, or error-free.
                    </p>
                    <p>
                        In no case shall OFFF THE ROAST, our staff, or partners be liable for any injury,
                        loss, or claim arising from your use of the Service or any products procured using
                        the Service.
                    </p>

                    <h2>SECTION 7 – GOVERNING LAW</h2>
                    <p>
                        These Terms of Service and any separate agreements whereby we provide you Services
                        shall be governed by and construed in accordance with the laws of the United
                        States.
                    </p>

                    <h2>CONTACT INFORMATION</h2>
                    <p>
                        Questions about the Terms of Service should be sent to us through our official
                        contact channels.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default TermsOfService;
